import * as regex from '@/configs/regex';
import ValidateError from '../ValidateError';
import context from '../../../../main';

export default {
  valid(question, answer) {
    if (!question.required) {
      return true;
    }

    if (question.inputMin && answer.text.length < question.inputMin) {
      throw new ValidateError(context.$t('check_minlength', { N: question.inputMin }));
    }

    if (question.inputMax && answer.text.length > question.inputMax) {
      throw new ValidateError(`最多只能输入${question.inputMax}个字`);
    }

    switch (question.inputRule) {
      case 'number':
        if (regex.numberRE.test(answer.text) === false) {
          throw new ValidateError(context.$t('check_numeric'));
        }
        break;
      case 'letter':
        if (regex.letterRE.test(answer.text) === false) {
          throw new ValidateError(context.$t('check_english'));
        }
        break;
      case 'chinese':
        if (regex.chineseRE.test(answer.text) === false) {
          throw new ValidateError(context.$t('check_chinese'));
        }
        break;
      case 'email':
        if (regex.emailRE.test(answer.text) === false) {
          throw new ValidateError(context.$t('check_email'));
        }
        break;
      case 'phone':
        if (regex.phoneRE.test(answer.text) === false) {
          throw new ValidateError(context.$t('check_mobile'));
        }
        break;
      default:
        return true;
    }

    return true;
  },
};
